// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__w_sft","prefix":"styles_prefix__TdjiJ","postfix":"styles_postfix__DYkLB"};